// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qsTA","container":"Footer_container__2hrAd","link":"Footer_link__23K8p","name":"Footer_name__3AvFa","contact":"Footer_contact__3aXXM"};